/**
 * 이어하기 팝업을 **이번 실행 동안 다시 묻지 않기** 위한 기억.
 *
 * 예전에는 닫힘이 `HomePage` 의 컴포넌트 state 라, 더보기나 결과에서 홈으로 돌아올 때마다
 * 화면이 다시 덮였다 — 보러 돌아온 그 내용 위에 (2026-09-16 실기기). 그렇다고 영구
 * 저장하면 다음 실행에서도 안 물어서 진행이 조용히 묻힌다.
 *
 * 그래서 `sessionStorage` 다: 앱을 다시 켜면 한 번은 다시 묻고, 켜 둔 동안에는 닫은 채로
 * 남는다. 기억하는 값은 **그 진행의 `updatedAt`** 이라, 진단을 더 하고 나오면 값이 달라져
 * 다시 한 번 묻는다 — "닫았다"가 "이 진행은 이미 봤다"는 뜻이 되게.
 */

export const RESUME_DISMISS_KEY = 'muzly:resumeDismissedAt';

/** 저장된 표식이 이 진행을 가리키나 — 형식이 깨졌으면 안 본 것으로 친다(다시 묻는 쪽이 안전). */
export const isResumeDismissed = (
  stored: string | null,
  updatedAt: number,
): boolean => stored !== null && Number(stored) === updatedAt;

/** 스토리지가 막힌 환경(프라이빗 모드·WebView 설정)에서도 화면은 돌아야 한다. */
export const readDismissed = (): string | null => {
  try {
    return sessionStorage.getItem(RESUME_DISMISS_KEY);
  } catch {
    return null;
  }
};

export const writeDismissed = (updatedAt: number): void => {
  try {
    sessionStorage.setItem(RESUME_DISMISS_KEY, String(updatedAt));
  } catch {
    // 못 적었으면 이번 화면에서만 닫힌다 — 화면 상태가 따로 있으니 기능은 산다.
  }
};
